import React, { useRef, useEffect } from "react";
import "./JWTsecretRow.css";
import { ReactComponent as CopyIcon } from "../Icons/Copy.svg";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";

const formatJsonValue = (value) => {
  if (!value) {
    return "{ }";
  }

  if (typeof value === "object") {
    return JSON.stringify(value, null, 2);
  }

  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

function JWTsecretRow({
  title = "JSON",
  value = "",
  onCopy,
  onClear,
  hasCopied,
  editable = false,
  onChange
}) {
  const preRef = useRef(null);
  const prevValueRef = useRef(value);
  const displayValue = formatJsonValue(value);

  useEffect(() => {
    if (!preRef.current) {
      return;
    }

    const hasExternalValueChange = value !== prevValueRef.current;

    if (hasExternalValueChange) {
      prevValueRef.current = value;
    }

    if ((hasExternalValueChange || preRef.current.textContent === "") && document.activeElement !== preRef.current) {
      preRef.current.textContent = displayValue;
    }
  }, [value, displayValue]);

  return (
    <div className="json-card">
      <div className="json-card-header">
        <span className="json-title">{title}</span>

        <div className="json-actions">
          <button className="json-btn" onClick={onCopy}>
            <CopyIcon className="json-icon" />
            {hasCopied ? "Copied" : "Copy"}
          </button>

          <button className="json-btn" onClick={onClear}>
            <DeleteIcon className="json-icon" />
            Clear
          </button>
        </div>
      </div>

      <div className="json-card-body">
        <pre
          ref={preRef}
          contentEditable={editable}
          suppressContentEditableWarning
          onInput={(event) => {
            if (editable && onChange) {
              onChange(event.currentTarget.textContent);
            }
          }}
        />
      </div>
    </div>
  );
}

export default JWTsecretRow;
